<div class="group-select">
  <div
    [class.pressed]="showDropdown"
    class="iv-select"
    (click)="toggleDropdown($event)"
  >
    <span class="label">{{label}}</span>
    <span class="separator">|</span>
    <input
      (blur)="onBlur(renameGroupInput.value)"
      (keyup.enter)="onEnterClick(renameGroupInput.value)"
      [readonly]="selectedData?.isDefault"
      (input)="onInputRenameGroup(renameGroupInput)"
      type="text"
      maxlength="20"
      class="value"
      id="groupInput"
      #renameGroupInput
      value="{{getValue(selectedData)}}"
    >
    <iv-live-input-tooltip #inputTooltip position="top"></iv-live-input-tooltip>
    <i class="material-icons"></i>
  </div>
  <ul *ngIf="showDropdown">
    <li
      (click)="onItemClick($event,item)"
      *ngFor="let item of data; index as i"
      [class.default]="!item?.isDefault"
      [class.selected]="item.id == selectedData.id"
    >
      <span>{{getValue(item)}}</span>
      <button
        (click)="onDeleteGroupClick($event, i)"
        *ngIf="!item?.isDefault"
        [id]="'deleteButton'+i"
        class="iv-img-button"
      >
        <div class='square-content'>
          <div>
            <span class="material-icons">&#xE14C;</span>
          </div>
        </div>
      </button>
    </li>
  </ul>
</div>


<dx-popup
  [(visible)]="deleteGroupPopupVisible"
  [closeOnOutsideClick]="true"
  [dragEnabled]="false"
  [height]="115"
  [position]="{ my: 'left top', at: 'bottom', of: '#deleteButton'+selectedIndex}"
  [shading]="false"
  [showCloseButton]="false"
  [showTitle]="false"
  [width]="240"
  class="delete-popup"
  title="popup"
>
  <div *dxTemplate="let data of 'content'">
    <span class="dx-popup-custom-title dx-popup-custom-title--small">Are you sure you want to delete group "{{getName()}}"?</span>
    <div class="buttons-container">
      <div
        (click)="onDeleteGroupApply()"
        class="iv-flat-button button apply"
      >
        <span>Delete</span>
      </div>
      <div
        (click)="onPopupCancel('deleteGroupPopupVisible')"
        class="iv-flat-button iv-flat-button-alert button cancel"
      >
        <span>Cancel</span>
      </div>
    </div>
  </div>
</dx-popup>
